import enviro from 'enviro';
export const useIsDebug = () => {
  return Boolean(enviro.debug('AUDIO_COMPONENTS'));
};